/* eslint-disable import/no-anonymous-default-export */
export default {
  "pre[class*=\"language-\"]": {
      "fontFamily": "Menlo, Monaco, Consolas, \"Andale Mono WT\", \"Andale Mono\", \"Lucida Console\", \"Lucida Sans Typewriter\", \"DejaVu Sans Mono\", \"Bitstream Vera Sans Mono\", \"Liberation Mono\", \"Nimbus Mono L\", \"Courier New\", Courier, monospace",
      "fontSize": "0.875rem",
      "lineHeight": "1.375",
      "direction": "ltr",
      "textAlign": "left",
      "whiteSpace": "pre-wrap",
      "wordSpacing": "normal",
      "wordBreak": "normal",
      "MozTabSize": "4",
      "OTabSize": "4",
      "tabSize": "4",
      "WebkitHyphens": "none",
      "MozHyphens": "none",
      "msHyphens": "none",
      "hyphens": "none",
      "background": "#121A24",
      "color": "#FFFFFF",
      "overflow": "auto"
  },
  "pre > code[class*=\"language-\"]": {
      "fontSize": "1em"
  },
  "pre[class*=\"language-\"]::-moz-selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  "pre[class*=\"language-\"] ::-moz-selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  "code[class*=\"language-\"]::-moz-selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  "code[class*=\"language-\"] ::-moz-selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  "pre[class*=\"language-\"]::selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  "pre[class*=\"language-\"] ::selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  "code[class*=\"language-\"]::selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  "code[class*=\"language-\"] ::selection": {
      "textShadow": "none",
      "background": "#222E3C"
  },
  ":not(pre) > code[class*=\"language-\"]": {
      "padding": ".1em",
      "borderRadius": ".3em"
  },
  "comment": {
      "color": "#4a5f78"
  },
  "prolog": {
      "color": "#4a5f78"
  },
  "doctype": {
      "color": "#4a5f78"
  },
  "cdata": {
      "color": "#4a5f78"
  },
  "punctuation": {
      "color": "#4a5f78"
  },
  "namespace": {
      "Opacity": ".7"
  },
  "tag": {
      "color": "#FFFFFF"
  },
  "operator": {
      "color": "#FFFFFF"
  },
  "number": {
      "color": "#FFFFFF"
  },
  "function": {
      "color": "#92D7D9"
  },
  "tag-id": {
      "color": "#ebf4ff"
  },
  "selector": {
      "color": "#ebf4ff"
  },
  "atrule-id": {
      "color": "#ebf4ff"
  },
  "code[class*=\"language-javascript\"]": {
      "color": "#B8D7FF"
  },
  "attr-name": {
      "color": "#7eb6f6"
  },
  "code.language-css": {
      "color": "#EAB454"
  },
  "code.language-scss": {
      "color": "#EAB454"
  },
  "boolean": {
      "color": "#EAB454"
  },
  "string": {
      "color": "#F2D197"
  },
  "entity": {
      "color": "#EAB454",
      "cursor": "help"
  },
  "url": {
      "color": "#EAB454"
  },
  ".language-css .token.string": {
      "color": "#EAB454"
  },
  ".language-scss .token.string": {
      "color": "#EAB454"
  },
  ".style .token.string": {
      "color": "#EAB454"
  },
  "attr-value": {
      "color": "#EAB454"
  },
  "keyword": {
      "color": "#EAB454"
  },
  "control": {
      "color": "#EAB454"
  },
  "directive": {
      "color": "#EAB454"
  },
  "unit": {
      "color": "#EAB454"
  },
  "statement": {
      "color": "#EAB454"
  },
  "regex": {
      "color": "#EAB454"
  },
  "atrule": {
      "color": "#EAB454"
  },
  "placeholder": {
      "color": "#EAB454"
  },
  "variable": {
      "color": "#EAB454"
  },
  "deleted": {
      "textDecoration": "line-through"
  },
  "inserted": {
      "borderBottom": "1px dotted #ebf4ff",
      "textDecoration": "none"
  },
  "italic": {
      "fontStyle": "italic"
  },
  "important": {
      "fontWeight": "bold",
      "color": "#7eb6f6"
  },
  "bold": {
      "fontWeight": "bold"
  },
  "pre > code.highlight": {
      "Outline": ".4em solid #34659d",
      "OutlineOffset": ".4em"
  },
  ".line-numbers.line-numbers .line-numbers-rows": {
      "borderRightColor": "#1f2932"
  },
  ".line-numbers .line-numbers-rows > span:before": {
      "color": "#222E3C"
  },
  ".line-highlight.line-highlight": {
      "background": "linear-gradient(to right, rgba(10, 163, 112, 0.2) 70%, rgba(10, 163, 112, 0))"
  }
}